import { useState } from "react";
import { specGroups } from "@/mocks/home";

export default function Specs() {
  const [active, setActive] = useState(0);
  const current = specGroups[active];

  return (
    <section id="specs" className="w-full bg-background-50 py-14 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10">
          <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
            TECH SPECS
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
            숫자로 보는 X9 PRO
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-foreground-700 text-base leading-relaxed">
            겉으로 보이지 않는 정교함까지 담아냈습니다. 라이더가 신뢰할 수 있는
            수치들만 남겼습니다.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-8">
          <div className="rounded-xl bg-background-100 p-2 grid grid-cols-4 lg:flex lg:flex-col gap-1">
            {specGroups.map((g, i) => (
              <button
                key={g.title}
                type="button"
                onClick={() => setActive(i)}
                className={`min-w-0 flex items-center justify-center lg:justify-between gap-1 lg:gap-3 px-1 sm:px-3 lg:px-4 py-3 rounded-md text-xs sm:text-sm font-medium cursor-pointer whitespace-nowrap transition-colors ${
                  active === i
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-800 hover:bg-background-200/70"
                }`}
              >
                <span className="min-w-0 flex items-center justify-center gap-1 sm:gap-2 whitespace-nowrap">
                  <i
                    className={`ri-${
                      ["headphone-line", "wifi-line", "battery-charge-line", "shield-line"][i]
                    }`}
                  ></i>
                  <span className="whitespace-nowrap">{g.title}</span>
                </span>
                <i className="ri-arrow-right-s-line flex-shrink-0 hidden lg:block"></i>
              </button>
            ))}
          </div>

          <div className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden">
            <div className="bg-background-100 px-6 py-4 flex items-center justify-between">
              <div className="font-heading font-semibold text-foreground-950">
                {current.title}
              </div>
              <div className="text-sm md:text-base font-semibold text-foreground-600 tracking-[0.16em] font-heading">
                X9 PRO
              </div>
            </div>
            <ul className="divide-y divide-background-200/70">
              {current.items.map((row) => (
                <li
                  key={row.label}
                  className="flex flex-col sm:flex-row sm:items-center sm:justify-between px-6 py-5 gap-2"
                >
                  <span className="text-sm text-foreground-500 font-medium tracking-wide">
                    {row.label}
                  </span>
                  <span className="flex flex-col items-start sm:items-end text-sm md:text-base text-foreground-950 font-semibold">
                    <span>{row.value}</span>
                    {row.label === "크기" && (
                      <span className="mt-1 text-[10px] font-medium tracking-wide text-foreground-400">
                        가로 × 세로 × 깊이
                      </span>
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
